'use strict';

import {communicationSubjectModel} from "../../models/communicationsubjectmodel.js";

export class CommunicationSubjectEditorCtrl
{
	ctrl = this;
	
	$scope;
	
	$mdDialog;
	
	jsDataService;
	
	subject;
	
	flow;
	
	uploadUrl;
	
	saveUrl;
	
	subjectForm;
	
	attachmentTs = 0;
	
	autosaveSkip = false;
	
	constructor($scope, $mdDialog, jsDataService, subject){
		this.$mdDialog = $mdDialog;
		this.jsDataService = jsDataService;
		this.subject = subject.getData();
		this.$scope = $scope;
		this.uploadUrl = this.jsDataService.get('cfgUploadUrl');
	}
	
	close() {
		this.$mdDialog.cancel();
	}
	
	save() {
		if(!this.isValid()) {
			return;
		}
		
		this.autosaveSkip = true;
		
		this.$mdDialog.hide(this.subject);
	}
	
	fileAdded($file) {
		const file = {
			id: '0',
			file_id: '0',
			name: $file.name,
			isFlow: true,
			flowFile: $file,
		};
		
		this.subject.attachment.push(file);
		
		return true;
	}
	
	fileSubmitted() {
		this.subject.flow.upload();
	}
	
	fileUploaded($file, $message) {
		const file = this.subject.attachment.find(f => f.flowFile?.uniqueIdentifier === $file.uniqueIdentifier);
		
		if(!file) {
			return;
		}
		
		try {
			const response = JSON.parse($message);
			file.file_id = response.fileId;
			this.$scope.subjectForm['attachment'].$setViewValue(Date.now());
		} catch(err) {
			
		}
	}
	
	removeFile(file) {
		this.subject.attachment = this.subject.attachment.filter(f => f !== file);
		this.$scope.subjectForm['attachment'].$setViewValue(Date.now());
	}
	
	isValid(){
		return this.subject.subject !== '' && this.subject.message !== '' && !this.subject.flow.isUploading();
	}
	
	getSaveData() {
		return {
			id: this.subject.id || '',
			parent_id: this.subject.parent_id || null,
			subject: this.subject.parent_id ? '' : this.subject.subject,
			message: this.subject.message,
			attachment: this.subject.attachment.map(({id, file_id}) => ({id, file_id})),
			object_number: this.subject.object_number,
		};
	}
	
	autosavePostFields(){
		return this.getSaveData();
	}
	
	autosaveSuccess(results){
		this.subject.id = results.data.id;
		this.subject.attachment = results.data.attachment;
		this.subject.delete_url = results.data.delete_url;
		
		this.jsDataService.set('draftMessage', results.data);
	}
	
	clear(){
		this.$scope.$parent.basicHttpConfigProcess({
			url: this.subject.delete_url,
			method: 'POST',
		}).then((response) => {
			if(response.data.success){
				this.subject.id = '';
				this.subject.message = '';
				this.subject.delete_url = '';
				this.subject.attachment = [];
				if(!this.subject.parent_id) {
					this.subject.subject = '';
				}
				this.jsDataService.set('draftMessage', null);
			}
		}, () => {});
	}
}